import React, { useState } from 'react';
import { balanceAPI } from '../services/api';

const WithdrawalModal = ({ isOpen, onClose, onSuccess }) => {
  const [step, setStep] = useState('form'); // 'form' or 'success'
  const [formData, setFormData] = useState({
    amount: '',
    paymentMethod: 'cashapp',
    paymentDetails: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [withdrawalId, setWithdrawalId] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const amount = parseFloat(formData.amount);
      if (isNaN(amount) || amount <= 0) {
        setError('Please enter a valid amount');
        return;
      }


      if (!formData.paymentDetails.trim()) {
        setError('Please enter your payment details');
        return;
      }

      const response = await balanceAPI.withdrawFunds(
        amount, 
        `User withdrawal - ${formData.paymentMethod}: ${formData.paymentDetails}`, 
        formData.paymentMethod
      );

      if (response && response.withdrawal_id) {
        setWithdrawalId(response.withdrawal_id);
        setStep('success');
        if (onSuccess) onSuccess();
      } else {
        setError('Failed to submit withdrawal request');
      }
    } catch (err) {
      console.error('Error submitting withdrawal:', err);
      setError(err.message || 'Failed to submit withdrawal request');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setStep('form');
    setFormData({
      amount: '',
      paymentMethod: 'cashapp',
      paymentDetails: ''
    });
    setError('');
    setWithdrawalId('');
    onClose();
  };

  if (!isOpen) return null;

  const getPaymentPlaceholder = () => {
    return formData.paymentMethod === 'cashapp' 
      ? 'Cash App tag (e.g., $username)' 
      : 'Zelle email or phone number';
  };

  const getPaymentMethodDisplay = () => {
    return formData.paymentMethod === 'cashapp' ? 'Cash App' : 'Zelle';
  };

  if (step === 'success') {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '24px',
          maxWidth: '500px',
          width: '90%',
          maxHeight: '90vh',
          overflowY: 'auto'
        }}>
          {/* Success Header */}
          <div style={{
            backgroundColor: '#d4edda',
            border: '1px solid #c3e6cb',
            borderRadius: '6px',
            padding: '16px',
            marginBottom: '16px'
          }}>
            <h3 style={{margin: '0 0 8px 0', color: '#155724', fontSize: '18px', fontWeight: '600'}}>
              Withdrawal Request Submitted!
            </h3>
            <p style={{margin: '0', color: '#155724', fontSize: '16px'}}>
              Your request for <strong>${formData.amount}</strong> via <strong>{getPaymentMethodDisplay()}</strong> has been submitted.
            </p>
          </div>

          {/* Processing Information */}
          <div style={{
            backgroundColor: '#fff3cd',
            border: '1px solid #ffeaa7',
            borderRadius: '6px',
            padding: '16px',
            marginBottom: '16px'
          }}>
            <h4 style={{margin: '0 0 12px 0', color: '#856404', fontWeight: '600'}}>
              📋 Processing Information
            </h4>
            <div style={{color: '#856404', fontSize: '14px', lineHeight: '1.5'}}>
              <p style={{margin: '0 0 8px 0'}}><strong>Amount:</strong> ${formData.amount}</p>
              <p style={{margin: '0 0 8px 0'}}><strong>Method:</strong> {getPaymentMethodDisplay()}</p>
              <p style={{margin: '0 0 8px 0'}}><strong>Payment Details:</strong> {formData.paymentDetails}</p>
              <p style={{margin: '0 0 8px 0'}}><strong>Reference ID:</strong> {withdrawalId}</p>
            </div>
          </div>

          {/* Important Information */}
          <div style={{
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: '6px',
            padding: '16px',
            marginBottom: '16px'
          }}>
            <h4 style={{margin: '0 0 12px 0', color: '#495057', fontWeight: '600'}}>
              ⚠️ Important Information
            </h4>
            <div style={{fontSize: '13px', color: '#6c757d', lineHeight: '1.5'}}>
              <p style={{margin: '0 0 6px 0'}}>• All requests are processed within 24 hours (average time: 1 hour)</p>
              <p style={{margin: '0 0 6px 0'}}>• All withdrawals are subject to verification</p>
              <p style={{margin: '0 0 6px 0'}}>• We may request additional verification for large amounts</p>
              <p style={{margin: '0 0 6px 0'}}>• Withdrawal requests cannot be cancelled once submitted</p>
              <p style={{margin: '0 0 6px 0'}}>• You will receive an email confirmation when your withdrawal is processed</p>
              <p style={{margin: '0 0 6px 0'}}>• Check your spam folder if you don't receive confirmation emails</p>
              <p style={{margin: '0 0 6px 0'}}>• Contact support if you don't receive your funds within 24 hours</p>
              <p style={{margin: '0 0 6px 0'}}>• Misuse of the withdrawal system may result in a ban</p>
              <p style={{margin: '0'}}>• Any questions or concerns please refer to the contact us page</p>
            </div>
          </div>

          <button
            onClick={handleClose}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '90vh',
        overflowY: 'auto'
      }}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
          <h2 style={{margin: 0, fontSize: '24px', fontWeight: '600'}}>Withdrawal Request</h2>
          <button
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#666'
            }}
          >
            ×
          </button>
        </div>

        {error && (
          <div style={{
            backgroundColor: '#f8d7da',
            border: '1px solid #f5c6cb',
            borderRadius: '6px',
            padding: '12px',
            marginBottom: '16px',
            color: '#721c24'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{marginBottom: '16px'}}>
            <label style={{display: 'block', marginBottom: '8px', fontWeight: '600'}}>
              Amount ($)
            </label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleInputChange}
              placeholder="Enter amount"
              min="0.01"
              step="0.01"
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '16px',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{marginBottom: '16px'}}>
            <label style={{display: 'block', marginBottom: '8px', fontWeight: '600'}}>
              Payment Method
            </label>
            <select
              name="paymentMethod"
              value={formData.paymentMethod}
              onChange={handleInputChange}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '16px',
                boxSizing: 'border-box'
              }}
            >
              <option value="cashapp">Cash App</option>
              <option value="zelle">Zelle</option>
            </select>
          </div>

          <div style={{marginBottom: '20px'}}>
            <label style={{display: 'block', marginBottom: '8px', fontWeight: '600'}}>
              Payment Details
            </label>
            <input
              type="text"
              name="paymentDetails"
              value={formData.paymentDetails}
              onChange={handleInputChange}
              placeholder={getPaymentPlaceholder()}
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '16px',
                boxSizing: 'border-box'
              }}
            />
            <p style={{margin: '4px 0 0 0', fontSize: '12px', color: '#666'}}>
              {formData.paymentMethod === 'cashapp' 
                ? 'Enter your Cash App tag (e.g., $username)'
                : 'Enter your Zelle email address or phone number'
              }
            </p>
          </div>

          <div style={{display: 'flex', gap: '12px'}}>
            <button
              type="button"
              onClick={handleClose}
              style={{
                flex: 1,
                padding: '12px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              style={{
                flex: 1,
                padding: '12px',
                backgroundColor: isLoading ? '#6c757d' : '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: isLoading ? 'not-allowed' : 'pointer'
              }}
            >
              {isLoading ? 'Submitting...' : 'Submit Request'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WithdrawalModal;
